import { duration } from "moment";
import { apiSlice } from "./apiSlice";

export const claimSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAllChange: builder.query({
            query: (params) => ({
                url: `Change`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Change"],
        }),

        // Export all data (without pagination) in Excel File
        getExportAllChange: builder.query({
            query: (params) => ({
                url: `Change`,
                params,
            }),
            keepUnusedDataFor: 0,
        }),

        getSingleChangeDetails: builder.query({
            query: ({changeId, params}) => ({
                url: `Change/${changeId}`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
        }),

        createChange: builder.mutation({
            query: ({ body }) => ({
                url: `Change`,
                method: "POST",
                body,
            }),
            invalidatesTags: ["Change"],
        }),

        updateChange: builder.mutation({
            query: ({ body }) => ({
                url: `Change`,
                method: "PUT",
                body,
            }),
            invalidatesTags: ["Change"],
        }),


        getAllChangeCount: builder.query({
            query: (params) => ({
                url: `Change/summary/${params.projectId}`,
                params,
            }),
            invalidatesTags: ["Change"],
        }),



    }),
});

export const {
    useGetAllChangeCountQuery,
    useCreateChangeMutation,
    useLazyGetAllChangeCountQuery,
    useUpdateChangeMutation,
    useGetSingleChangeDetailsQuery,
    useLazyGetSingleChangeDetailsQuery, 
    useLazyGetAllChangeQuery,
    useLazyGetExportAllChangeQuery,

} = claimSlice;